import { getCountryCode } from "@/utils/common-functions";

export const getRateReqMapper = {
  "shipFrom.name": "FromAddress.name",
  "shipFrom.streetAddress": "FromAddress.streetAddress",
  "shipFrom.country": {
    key: "FromAddress.countryCode",
    transform: (country: string) => getCountryCode(country),
  },
  "shipFrom.postCode": "FromAddress.postalCode",
  "shipFrom.stateCode": "FromAddress.stateCode",
  "shipFrom.city": "FromAddress.city",
  "shipFrom.isResidence": "FromAddress.isResidence",
  "shipTo.country": {
    key: "ToAddress.countryCode",
    transform: (country: string) => getCountryCode(country),
  },
  "shipTo.name": "ToAddress.name",
  "shipTo.streetAddress": "ToAddress.streetAddress",
  "shipTo.postCode": "ToAddress.postalCode",
  "shipTo.stateCode": "ToAddress.stateCode",
  "shipTo.city": "ToAddress.city",
  "shipTo.isResidence": "ToAddress.isResidence",
  shipDate: "ShipDate",
  loadType: "loadType",
  "shippingItems[]": {
    key: "lineItems",
    transform: (items: any[]) => {
      let lineItems: any = [];
      if (items.find((item) => !item?.isLTL)) {
        items.forEach((item) => {
          for (let i = 0; i < item.quantity; i++) {
            lineItems.push({
              length: item.length ? parseFloat(item.length) : 0,
              height: item.height ? parseFloat(item.height) : 0,
              width: item.width ? parseFloat(item.width) : 0,
              weight: parseFloat(item.weight),
              declaredValue: item.insurance
                ? {
                    currency: "CAD",
                    amount: item.insurance ? parseFloat(item.insurance) : 0,
                  }
                : null,
              PackagingType: item.package ? item.package.code : null,
              InsuranceType: item.InsuranceType
                ? item.InsuranceType.code
                : "NONE",
            });
          }
        });
      } else {
        lineItems = items.map((item) => ({
          length: item.length ? parseFloat(item.length) : 0,
          height: item.height ? parseFloat(item.height) : 0,
          width: item.width ? parseFloat(item.width) : 0,
          weight: parseFloat(item.weight),
          numberOfPieces: item.numberOfPieces,
          isDangerousGoodsIncluded: item.isDangerousGoodsIncluded,
          description: item.description,
          FreightClass: item.freightClass,
          packagingTypeCode: item.packagingTypeCode,
          typeOfGoods: item.typeOfGoods,
          vehicleType: item.vehicleType,
          declaredValue: item.insurance
            ? {
                currency: "CAD",
                amount: item.insurance ? parseFloat(item.insurance) : 0,
              }
            : null,
          InsuranceType: item.InsuranceType ? item.InsuranceType.code : "NONE",
        }));
      }

      return lineItems;
    },
  },
  unitOfMeasurement: "unitOfMeasurement",
  carrierName: {
    key: "ShippingCarriers",
    transform: (carrier: any) => (carrier ? [carrier] : null),
  },
  carrierService: {
    key: "CarrierServiceTypeList",
    transform: (service: any) => (service ? [service] : null),
  },
  "serviceOptions[].optionCode": "serviceOptions[].code",
  "serviceOptions[].amount": "serviceOptions[].amount",
  "serviceOptions[].qualifier": "serviceOptions[].qualifier",
  shippingCarrierAccountId: "shippingCarrierAccountId",
  accountType: "accountType",
  NumberOfPieces: "NumberOfPieces",
  paymentInformation: "paymentInformation",
  serviceType: "ServiceType",
  handlingUnitOne: "handlingUnitOne",
  handlingUnitTwo: "handlingUnitTwo",
  guestEmail: "guestEmail",
  guestName: "guestName",
};
